// Generated by purs version 0.13.0
"use strict";
var Data_Maybe = require("../Data.Maybe/index.js");
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Action_CreatureAct = require("../Ritoppu.Action.CreatureAct/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Model_Stats = require("../Ritoppu.Model.Stats/index.js");
var Ritoppu_Mutation_Player = require("../Ritoppu.Mutation.Player/index.js");
var Ritoppu_Mutation_Point = require("../Ritoppu.Mutation.Point/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var Ritoppu_Mutation_Stats = require("../Ritoppu.Mutation.Stats/index.js");
var playerTurn = function (game) {
    return {
        stage: {
            player: {
                pos: game.stage.player.pos,
                stats: game.stage.player.stats,
                turn: game.stage.player.turn + 5 | 0,
                inventory: game.stage.player.inventory,
                level: game.stage.player.level,
                equipment: game.stage.player.equipment
            },
            tiles: game.stage.tiles,
            size: game.stage.size,
            seen: game.stage.seen,
            items: game.stage.items,
            fovMask: game.stage.fovMask,
            creatures: game.stage.creatures
        },
        dungeonLevel: game.dungeonLevel
    };
};
var wait = function ($15) {
    return Ritoppu_Action_CreatureAct.creatureAct(playerTurn($15));
};
var addExperience = function (xp) {
    return function (stage) {
        return {
            player: Ritoppu_Mutation_Player.gainXp(xp)(stage.player),
            tiles: stage.tiles,
            size: stage.size,
            seen: stage.seen,
            items: stage.items,
            fovMask: stage.fovMask,
            creatures: stage.creatures
        };
    };
};
var attack = function (pos) {
    return function (creature) {
        return function (game) {
            var damage = Ritoppu_Model_Stats.damageTo(game.stage.player.stats)(creature.stats);
            if (damage === 0) {
                return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.AttackHarmlessM(creature)))(Ritoppu_Action_CreatureAct.creatureAct(playerTurn(game)));
            };
            if (damage >= creature.stats.hp) {
                return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.AttackKillM(creature)))(Ritoppu_Action_CreatureAct.creatureAct(playerTurn({
                    stage: addExperience(creature.xp)(Ritoppu_Mutation_Stage.addItem(pos)(Ritoppu_Model_Item.newCorpse(creature))(Ritoppu_Mutation_Stage.removeCreature(pos)(game.stage))),
                    dungeonLevel: game.dungeonLevel
                })));
            };
            return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.AttackM(creature, damage)))(Ritoppu_Action_CreatureAct.creatureAct(playerTurn({
                stage: Ritoppu_Mutation_Stage.updateCreature(pos)(function (c) {
                    return {
                        type: c.type,
                        stats: Ritoppu_Mutation_Stats.takeDamage(damage)(c.stats),
                        turn: c.turn,
                        aiStrategy: c.aiStrategy,
                        xp: c.xp
                    };
                })(game.stage),
                dungeonLevel: game.dungeonLevel
            })));
        };
    };
};
var move = function (dir) {
    return function (v) {
        var dest = Ritoppu_Mutation_Point.moveTo(dir)(v.stage.player.pos);
        var v1 = Ritoppu_Model_Stage.creatureAt(v.stage)(dest);
        if (v1 instanceof Data_Maybe.Just) {
            return attack(dest)(v1.value0)(v);
        };
        if (Ritoppu_Model_Stage.availableToMoveTo(v.stage)(dest)) {
            return Ritoppu_Action_CreatureAct.creatureAct(playerTurn({
                stage: Ritoppu_Mutation_Stage.updateFov({
                    player: {
                        pos: dest,
                        stats: v.stage.player.stats,
                        turn: v.stage.player.turn,
                        inventory: v.stage.player.inventory,
                        level: v.stage.player.level,
                        equipment: v.stage.player.equipment
                    },
                    tiles: v.stage.tiles,
                    size: v.stage.size,
                    seen: v.stage.seen,
                    items: v.stage.items,
                    fovMask: v.stage.fovMask,
                    creatures: v.stage.creatures
                }),
                dungeonLevel: v.dungeonLevel
            }));
        };
        return Ritoppu_Action.withAction(v)(new Ritoppu_Action.LogMessage(Ritoppu_Action.HitAWallM.value));
    };
};
module.exports = {
    move: move,
    wait: wait
};
